export default "__VITE_ASSET__43051844__"